module.exports = __webpack_public_path__ + "img/about-4-1.946bbbf6.png";